/* eslint-disable no-restricted-imports */
import { useState } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import getPreferredGameCurrency from '@/actions/getPreferredGameCurrency';
import useCurrencyChangeListener from '@/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCurrencyChangeListener';

const usePreferredInGameCurrency = (initialInGameCurrency?: string) => {
  const [profileCurrency, setProfileCurrency] = useState(initialInGameCurrency);
  const { setInGameCurrency } = useGameContext();

  useCurrencyChangeListener({
    onChange: async () => {
      const preferredInGameCurrency = await getPreferredGameCurrency();
      setInGameCurrency(preferredInGameCurrency);
      setProfileCurrency(preferredInGameCurrency);
    },
  });

  return {
    profileCurrency,
    setCurrency: setProfileCurrency,
  };
};

export default usePreferredInGameCurrency;
